import { Map } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FETCH_SERVICE_SETTING,
	FETCH_SERVICE_SETTING_SUCCESS,
	FETCH_SERVICE_SETTING_FAILED,

	UPDATE_SERVICE_SETTING,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	data: Map(),

	loadingStatus: NONE,
	loadingStatusMessage: '',
});

export default function serviceSetting(state = initialState, action) {
	switch (action.type) {
		case START_FETCH_SERVICE_SETTING:
			return state
				.set('loadingStatus', LOADING);

		case FETCH_SERVICE_SETTING_SUCCESS:
			return state
				.set('data', Map(action.serviceSetting))
				.set('loadingStatus', SUCCESS);

		case FETCH_SERVICE_SETTING_FAILED:
			return state
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		case UPDATE_SERVICE_SETTING:
			return state.set('data', Map(action.serviceSetting));

		default:
			return state;
	}
}
